import React from 'react';
import type { ProductSummaryDescriptorProps } from 'Cms/product-summary/resolver';
import 'Cms/product-summary/resolver';
import { getProductProps } from 'Components/widgets/product/Product.mapper';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { ProductTeaser } from 'Components/widgets/product-teaser/ProductTeaser';
type ProducstSummaryLineProps = ProductSummaryDescriptorProps & {
  id?: string;
};
export const ProductSummaryLine = ({ color, config, id, product }: ProducstSummaryLineProps) =>
  !!product && (
    <SiteContainer className="Line" id={id}>
      <ProductTeaser
        card={{
          heading: {
            iconName: product?.resortId?.toLowerCase(),
            title: product?.name,
          },
          link: {
            url: product?.href,
          },
          text: {
            text: product?.title,
          },
          color: color,
        }}
        product={getProductProps({
          config,
          product,
        })}
      />
    </SiteContainer>
  );
